export function setFocusOnFirstErrorField(formElement, errorSelector) {
  formElement.querySelector(errorSelector).focus()
}